export default "__VITE_ASSET__lvGTgd6___"